import { CommentType, ConstantValue, DocComment, DocSection } from '../../src/types/constants';
import { quoteString } from './util';

const renderCommentType = (type: CommentType): string => {
  switch (type) {
    case 'link':
      return 'Link';
    case 'description':
      return 'Description';
    case 'units':
      return 'Units';
    case 'inventory2018':
      return 'GHG Inventory 2018';
    case 'inventory2022':
      return 'GHG Inventory 2022';
    case 'ngaf2024':
      return 'NGAF 2024';
    case 'nir2024':
      return 'National Inventory Report 2024';
    case 'type':
      return 'Type';
    case 'reference':
      return 'Reference';
    case 'appendixA':
      return 'Guidelines Appendix A';
    case 'nir2024Vol1':
      return 'National Inventory Report 2024 Volume 1';
    case 'nir2024Vol2':
      return 'National Inventory Report 2024 Volume 2';
  }
};

function renderSectionValuesMarkdown(values: ConstantValue[]): string {
  // Create a markdown table to render all value records.

  if (values.some((value) => value.comments?.length > 0 && value.path.length > 1)) {
    const header = `| Path | Comments | Value |\n| --- | --- | --- |\n`;
    const rows = values.map((value) => {
      return `| ${quoteString(value.path.join('.'))} | ${value.comments} | ${value.value} |\n`;
    });
    return header + rows.join('');
  }

  const header = `| Path | Value |\n| --- | --- |\n`;
  const rows = values.map((value) => {
    return `| ${quoteString(value.path.join('.'))} | ${value.value} |\n`;
  });
  return header + rows.join('');
}

const renderSectionCommentsMarkdown = (comments: DocComment[]): string => {
  if (comments.length === 0) {
    return '';
  }
  return `| | |\n| --- | --- |\n${comments
    .map((comment) => ({ text: comment.text, type: renderCommentType(comment.type) }))
    .sort((a, b) => a.type.localeCompare(b.type))
    .map((comment) => `| ${comment.type} | ${comment.text} |`)
    .join('\n')}`;
};

const renderSectionMarkdown = (section: DocSection): string => {
  return `## ${section.name}\n
${renderSectionCommentsMarkdown(section.comments)}
\n
${renderSectionValuesMarkdown(section.values)}`;
};

export { renderCommentType, renderSectionCommentsMarkdown, renderSectionMarkdown, renderSectionValuesMarkdown };
